const CSRF_COOKIE = '__c_token__'

export function getCsrfCookie() {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${CSRF_COOKIE}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
  return undefined
}

export async function fetchCsrfToken() {
  // The CSRF endpoint only exists on v1 (/api/auth/csrf-token), not under /api/v2/.
  await fetch(new URL("../auth/csrf-token", import.meta.env.VITE_API), {
    credentials: 'include',
  })
  return getCsrfCookie()
}
